import { render, staticRenderFns } from "./default-app-bar.vue?vue&type=template&id=583b1820&"
import script from "./default-app-bar.vue?vue&type=script&lang=js&"
export * from "./default-app-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports